(function () {
  'use strict';

  class HoverZoom {
    constructor(root) {
      this.root = root || document;
      this.DOM = undefined;
      this.zoomRatio = 2;
      this.imageToOverlayElement = null;

      this.onImageClick = (event) => {
        event.preventDefault();
        const imageElement = event.currentTarget;
        this.magnify(imageElement, event);
      };

      this.init();
    }

    init() {
      this.DOM = {};
      this.DOM.images = this.root.querySelectorAll('.js-image-magnify-hover');

      if (!this.DOM.images.length) return;

      this.zoomRatio = 2;
      this.imageToOverlayElement = new WeakMap();

      this.setup();
    }

    setup() {
      this.DOM.images.forEach((imageElement) => {
        imageElement.addEventListener('click', this.onImageClick);
      });
    }

    magnify(imageElement, initialEvent) {
      const overlayElement = this.createOverlay(imageElement);

      const handleMouseMove = (event) => { this.moveWithHover(imageElement, event); };
      const handleMouseLeave = () => { this.removeOverlay(imageElement); };
      const handleClick = () => { this.removeOverlay(imageElement); };

      overlayElement.addEventListener('mousemove', handleMouseMove);
      overlayElement.addEventListener('mouseleave', handleMouseLeave);
      overlayElement.addEventListener('click', handleClick);

      this.imageToOverlayElement.set(imageElement, {
        overlayElement: overlayElement,
        handleMouseMove: handleMouseMove,
        handleMouseLeave: handleMouseLeave,
        handleClick: handleClick,
      });

      if (initialEvent) this.moveWithHover(imageElement, initialEvent);
    }

    createOverlay(imageElement) {
      const preloadImage = document.createElement('img');
      preloadImage.setAttribute('src', '' + imageElement.src);

      const overlayElement = document.createElement('div');
      this.prepareOverlay(overlayElement, preloadImage);

      imageElement.style.opacity = '50%';

      preloadImage.onload = () => {
        imageElement.parentElement.insertBefore(overlayElement, imageElement);
        imageElement.style.opacity = '100%';
      };

      return overlayElement;
    }

    prepareOverlay(containerElement, imageElement) {
      containerElement.setAttribute('class', 'image-magnify-full-size js-image-magnify-full-size');
      containerElement.setAttribute('aria-hidden', 'true');
      containerElement.style.backgroundImage = "url('" + imageElement.src + "')";
      containerElement.style.backgroundColor = 'var(--gradient-background)';
    }

    moveWithHover(imageElement, event) {
      const overlayRecord = this.imageToOverlayElement.get(imageElement);
      if (!overlayRecord) return;
      const overlayElement = overlayRecord.overlayElement;

      const aspectRatio = imageElement.height / imageElement.width;
      const overlayRect = event.target.getBoundingClientRect();
      const xPosition = event.clientX - overlayRect.left;
      const yPosition = event.clientY - overlayRect.top;
      const xPercent = (xPosition / (imageElement.clientWidth / 100)) + '%';
      const yPercent = (yPosition / ((imageElement.clientWidth * aspectRatio) / 100)) + '%';

      overlayElement.style.backgroundPosition = xPercent + ' ' + yPercent;
      overlayElement.style.backgroundSize = (imageElement.width * this.zoomRatio) + 'px';
    }

    removeOverlay(imageElement) {
      const overlayRecord = this.imageToOverlayElement.get(imageElement);
      if (!overlayRecord) return;

      const { overlayElement, handleMouseMove, handleMouseLeave, handleClick } = overlayRecord;
      overlayElement.removeEventListener('mousemove', handleMouseMove);
      overlayElement.removeEventListener('mouseleave', handleMouseLeave);
      overlayElement.removeEventListener('click', handleClick);
      overlayElement.remove();
      this.imageToOverlayElement.delete(imageElement);
    }

    destroy() {
      if (!this.DOM) return;

      this.DOM.images.forEach((imageElement) => {
        imageElement.removeEventListener('click', this.onImageClick);
        this.removeOverlay(imageElement);
      });

      this.DOM = undefined;
    }
  }

  window.Universe.HoverZoom = HoverZoom;
})();
